export enum NgStorage {
  TOKEN = 'token',
  REDIRECT_URL = 'redirect-url',
  LOADER = 'loader',
  USER = 'user',
  USER_PERMISSIONS = 'user-permissions',
  BASE_PERMISSIONS = 'base-permissions',
  USER_EMAIL = 'user-email',
  IMAGES = 'images-array',
}
